module.exports = __webpack_public_path__ + "img/component.a69885f8.svg";